import { useEffect } from 'react';
import { useAppStore } from '../stores/appStore';

export type Theme = 'dark' | 'light';

/** Apply the theme class to <html> so CSS variables switch. */
export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  root.classList.toggle('light', theme === 'light');
  root.classList.toggle('dark', theme === 'dark');
  root.style.colorScheme = theme;
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) meta.content = theme === 'light' ? '#f5f2eb' : '#040404';
}

/** Keeps the document in sync with the persisted theme preference. */
export function useApplyTheme() {
  const theme = useAppStore((s) => s.theme);
  const setTheme = useAppStore((s) => s.setTheme);

  // Honour a one-off `?theme=` override (also applied pre-paint in index.html).
  useEffect(() => {
    const q = new URLSearchParams(window.location.search).get('theme');
    if (q === 'light' || q === 'dark') setTheme(q);
  }, [setTheme]);

  useEffect(() => applyTheme(theme), [theme]);
}

export function useTheme() {
  const theme = useAppStore((s) => s.theme);
  const setTheme = useAppStore((s) => s.setTheme);
  return { theme, setTheme, toggle: () => setTheme(theme === 'dark' ? 'light' : 'dark') };
}
